import { useEffect } from 'react';

const appcuesInlineConfigScriptSnippet = `(function () {
    if (!window.AppcuesReady) {
        window.AppcuesReady = function (callback) {
            callback && window.AppcuesReady.q.push(callback);
            if (window.Appcues) {
                while (window.AppcuesReady.q.length) {
                    cb = window.AppcuesReady.q.shift();
                    if (typeof cb === 'function') cb();
                }
            }
        };
        window.AppcuesReady.q = [];
    }
})();`;

const appcuesInlineConfigScriptInvokerSnippet = `AppcuesReady(() => {});`;

export default function useAppcuesScript() {
    useEffect(() => {
        const configScript = document.createElement('script');
        configScript.appendChild(
            document.createTextNode(appcuesInlineConfigScriptSnippet)
        );
        document.body.appendChild(configScript);

        const appcuesInlineConfigScriptInvoker = document.createElement(
            'script'
        );
        appcuesInlineConfigScriptInvoker.appendChild(
            document.createTextNode(appcuesInlineConfigScriptInvokerSnippet)
        );
        document.body.appendChild(appcuesInlineConfigScriptInvoker);

        const mainScript = document.createElement('script');
        mainScript.src = '//fast.appcues.com/89172.js';
        mainScript.async = true;
        mainScript.defer = true;

        mainScript.onload = () => {
            window.AppcuesReady();
        };

        document.body.appendChild(mainScript);
    }, []);
}
